import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart } from 'primereact/chart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faMap } from '@fortawesome/free-solid-svg-icons';

import { Chart as ChartJS } from 'chart.js';

ChartJS.register(ChartDataLabels);


  // Start of Selection
export const FieldCard = ({ field_date, application_name, plot_name, worker_name, prescription, applied, r_mean_speed, t_mean_speed, onClick }) => {
    const navigate = useNavigate();

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = date.toLocaleString('default', { month: 'short' });
        return `${day}-${month}`;
    };

    const speedData = {
        labels: [''],
        datasets: [
            {
                label: 'Real',
                backgroundColor: '#FFCE56',
                data: [r_mean_speed || 0]
            },
            {
                label: 'Teórica',
                backgroundColor: '#36A2EB',
                data: [t_mean_speed || 0]
            }
        ]
    };

    const doseData = {
        labels: [''],
        datasets: [
            {
                label: 'Real',
                backgroundColor: '#FFCE56',
                data: [applied || 0]
            },
            {
                label: 'Teórica',
                backgroundColor: '#36A2EB',
                data: [prescription || 0]
            }
        ]
    };

    // Calcular el valor máximo para la velocidad y la dosis
    const maxSpeed = Math.max(r_mean_speed || 0, t_mean_speed || 0);
    const maxDose = Math.max(applied || 0, prescription || 0);

    // Opciones para el gráfico de velocidad
    const speedOptions = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
            legend: {
                position: 'top',
                labels: { 
                    color: 'black',
                    usePointStyle: true,
                    pointStyle: 'circle'
                }
            },
            datalabels: {
                color: 'black',
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value) => (value ? value.toString() : '')
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                suggestedMax: maxSpeed + 1,
                ticks: { color: 'black', count: 5 },
                grid: { display: false }
            },
            y: {
                display: false
            }
        },
        animation: false
    };
  
    // Opciones para el gráfico de dosis
    const doseOptions = {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: 'y',
        plugins: {
            legend: {
                position: 'top',
                labels: { 
                    color: 'black',
                    usePointStyle: true,
                    pointStyle: 'circle'
                }
            },
            datalabels: {
                color: 'black',
                anchor: 'end',
                align: 'end',
                offset: 0,
                formatter: (value) => (value ? value.toString() : '')
            }
        },
        scales: {
            x: {
                beginAtZero: true,
                suggestedMax: maxDose + 10, // <--- Aquí tu margen de +10
                ticks: { color: 'black', count: 5, precision: 0 },
                grid: { display: false }
            },
            y: {
                display: false
            }
        },
        animation: false
    };
    

    return (
        <Card 
            className={`w-full mt-3`}
            style={{ 
                backgroundColor: 'white', 
                borderRadius: '10px',
                border: 'solid',
                borderWidth: '1px',
                borderColor: '#DEE2E6',
                boxShadow: '4px 4px 8px rgba(0, 0, 0, 0.3)',
                maxWidth: '450px'
            }}
        >
            <div className='p-3'>
                <div className='flex justify-content-between align-items-center mb-1'>
                    <span 
                        style={{ 
                            color: 'black', 
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis'
                        }} 
                        className='font-bold text-xl'
                    >
                        {plot_name}
                    </span>
                    <span className='flex align-items-center justify-content-end text-sm' style={{ color: 'black', minWidth: '70px', marginTop: '6px' }}>{formatDate(field_date)}</span>
                </div>
                <div className='flex justify-content-between align-items-center mb-2'>
                    <span style={{ color: 'black'}} className='text-sm'>
                        {application_name}
                    </span>
                    
                    <span 
                        style={{ 
                            color: 'black', 
                            fontSize: '14px', 
                            textDecoration: 'underline', 
                            cursor: 'pointer'
                        }}
                        onClick={onClick}
                    >
                        <FontAwesomeIcon style={{ color: 'black', fontSize: '14px' }} icon={faMap} className='mr-2' />Ver mapa
                    </span>
                </div>
                <div className='flex flex-column'>
                    <span style={{ color: 'black', fontWeight: 600 }}>Velocidad (Km/h)</span>
                    {r_mean_speed || t_mean_speed ? (
                        <Chart 
                            style={{ height: '100px', cursor: 'pointer' }} 
                            type="bar" 
                            data={speedData} 
                            options={speedOptions}
                        />
                    ) : (
                        <span style={{ height: '100px', color: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Datos no disponibles</span>
                    )}
                    {applied || prescription ? (
                        <>
                            <span className='mt-2' style={{ color: 'black', fontWeight: '600' }}>Dosis (L/Ha)</span>
                            <Chart 
                                style={{ height: '100px', cursor: 'pointer' }} 
                                type="bar" 
                                data={doseData} 
                                options={doseOptions}
                            />
                        </>

                    ) : (
                        <span className='mt-2' style={{ height: '121.6px' }}></span>
                    )}
                </div>   
            </div>
            <div style={{ backgroundColor: '#f0f0f0', borderRadius: '0px 0px 10px 10px' }} className='w-full flex align-items-center pl-3 pr-3 pt-2 pb-2'>
                <FontAwesomeIcon style={{ color: 'black', fontSize: '14px' }} icon={faUser} className='mr-2' />
                <span 
                    style={{ 
                        color: 'black', 
                        fontSize: '14px', 
                        whiteSpace: 'nowrap', 
                        overflow: 'hidden', 
                        textOverflow: 'ellipsis'
                    }}
                >
                    {worker_name}
                </span>
            </div>
        </Card>
    );
};